module.exports = __webpack_public_path__ + "g2-logo-small-4dd5fecc4695b1e3b7bc04f3ef275a89.svg";